import { SVGAttributes } from 'react'

export default function ApplicationLogo ({ className }: any) {
    return (
        <div>
            <img className={className} src='/images/logo.png' />
        </div>
    )
}
